import { render, staticRenderFns } from "./InActivity.vue?vue&type=template&id=53e70cf2"
import script from "./InActivity.vue?vue&type=script&lang=js"
export * from "./InActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports